namespace $.$$ {
	
	export class $shm_hitalama_app_book extends $.$shm_hitalama_app_book {
		
		@ $mol_mem_key
		maps_list_toggle_visible( spread: string ) {
			return spread === 'maps' ? super.maps_list_toggle_visible( spread ) : []
		}

		@ $mol_mem_key
		projects_list_toggle_visible( spread: string ) {
			return spread === 'projects' ? super.projects_list_toggle_visible( spread ) : []
		}

		profile_id() {
			const profile = this.$.$shm_hitalama_profile.current()
			return profile?.Login()?.val() || profile?.link().toString() || ''
		}
		
	}
	
}
